import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Clock, LogOut, Mail } from 'lucide-react';

const PendingApprovalPage = () => {
    const { user, logout } = useAuth();

    return (
        <div className="min-h-screen bg-background flex items-center justify-center p-4" data-testid="pending-approval-page">
            <Card className="max-w-md w-full">
                <CardContent className="pt-10 pb-8 text-center">
                    <div className="w-20 h-20 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center mx-auto mb-6">
                        <Clock className="h-10 w-10 text-amber-600" />
                    </div>
                    <h1 className="font-heading text-2xl font-bold mb-3">
                        Membership Pending
                    </h1>
                    <p className="text-muted-foreground mb-6">
                        Thank you for your interest in joining the HAAPE Hub and becoming part of our Workforce Ecosystem.
                    </p>
                    <div className="bg-muted/50 rounded-lg p-4 mb-6 text-left">
                        <p className="text-sm text-muted-foreground">
                            <strong>What happens next?</strong>
                        </p>
                        <ul className="text-sm text-muted-foreground mt-2 space-y-1 list-disc list-inside">
                            <li>Your request will be reviewed by our team</li>
                            <li>We may request additional information or a virtual meeting</li>
                            <li>The review usually takes about 7 business days</li>
                            <li>You will be notified once access is approved</li>
                        </ul>
                    </div>
                    <div className="flex flex-col gap-3">
                        <a href="mailto:info@haape.org">
                            <Button variant="outline" className="w-full gap-2">
                                <Mail className="h-4 w-4" />
                                Contact Us
                            </Button>
                        </a>
                        <Button variant="ghost" className="w-full gap-2" onClick={logout} data-testid="logout-btn">
                            <LogOut className="h-4 w-4" />
                            Sign Out
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default PendingApprovalPage;
